import React, { useEffect, useRef, useState } from "react";

const VisualBand = ({
  image,
  alt,
  quote,
  caption,
  testId = "visual-band",
}) => {
  const ref = useRef(null);
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const el = ref.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const winH = window.innerHeight;
      // Map section center to a -1..1 range
      const center = rect.top + rect.height / 2;
      const norm = (center - winH / 2) / winH;
      setOffset(Math.max(-1, Math.min(1, norm)));
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <section
      ref={ref}
      data-testid={testId}
      className="relative h-[60vh] min-h-[420px] lg:h-[75vh] overflow-hidden"
    >
      <div
        className="absolute inset-0 -top-12 -bottom-24"
        style={{ transform: `translate3d(0, ${offset * -60}px, 0) scale(1.1)` }}
      >
        <img
          src={image}
          alt={alt}
          className="absolute inset-0 w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-navy-900/90 via-navy-900/60 to-navy-800/20" />
      <div className="absolute inset-0 grain opacity-30" />

      {/* Premium glow */}
      <div className="absolute -top-1/3 -left-1/4 w-[50%] h-[140%] bg-gradient-to-br from-sky-300/10 via-transparent to-transparent blur-3xl pointer-events-none" />

      <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center">
        <div className="max-w-2xl">
          <div className="flex items-center gap-3 mb-6">
            <div className="h-px w-12 bg-sky-300" />
            <div className="text-xs uppercase tracking-[0.32em] text-sky-300 font-semibold">
              {caption?.replace(/^·\s*/, "")}
            </div>
          </div>
          <blockquote className="font-display text-2xl sm:text-3xl lg:text-4xl xl:text-5xl text-white leading-[1.15] tracking-tight">
            <span className="text-sky-300 mr-1">&ldquo;</span>
            {quote}
            <span className="text-sky-300 ml-1">&rdquo;</span>
          </blockquote>
          <div className="mt-8 text-[11px] uppercase tracking-[0.28em] text-white/50 font-medium">
            PORT&rsquo;S COLLECTORS
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisualBand;
